import React from 'react';
import { Section } from './ui/Section';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function Contact() {
  return <Section id="contact" bg="offwhite" data-id="element-23">
      <div className="grid md:grid-cols-2 gap-12" data-id="element-24">
        <div data-id="element-25">
          <h2 className="text-gold font-bold tracking-wider text-sm uppercase mb-2" data-id="element-26">
            Contact Us
          </h2>
          <h3 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-6" data-id="element-27">
            Get in Touch
          </h3>
          <p className="text-gray-600 mb-8" data-id="element-28">
            Our team is ready to assist you with your financial needs. Visit us,
            call, or email us today.
          </p>

          <div className="space-y-6" data-id="element-29">
            <div className="flex items-start" data-id="element-30">
              <div className="bg-white p-3 rounded-lg shadow-sm mr-4" data-id="element-31">
                <MapPin className="h-6 w-6 text-gold" data-id="element-32" />
              </div>
              <div data-id="element-33">
                <h4 className="font-bold text-navy" data-id="element-34">Visit Us</h4>
                <p className="text-gray-600" data-id="element-35">Plot 20582, Block 3, Unit 9/10</p>
                <p className="text-gray-600" data-id="element-36">Gaborone, Botswana</p>
                <p className="text-gray-500 text-sm mt-1" data-id="element-37">
                  P.O Box 3568, Gaborone
                </p>
              </div>
            </div>

            <div className="flex items-start" data-id="element-38">
              <div className="bg-white p-3 rounded-lg shadow-sm mr-4" data-id="element-39">
                <Phone className="h-6 w-6 text-gold" data-id="element-40" />
              </div>
              <div data-id="element-41">
                <h4 className="font-bold text-navy" data-id="element-42">Call Us</h4>
                <p className="text-gray-600" data-id="element-43">+267 74 833 041</p>
                <p className="text-gray-600" data-id="element-44">+267 77 685 555</p>
              </div>
            </div>

            <div className="flex items-start" data-id="element-45">
              <div className="bg-white p-3 rounded-lg shadow-sm mr-4" data-id="element-46">
                <Mail className="h-6 w-6 text-gold" data-id="element-47" />
              </div>
              <div data-id="element-48">
                <h4 className="font-bold text-navy" data-id="element-49">Email Us</h4>
                <a href="mailto:derien@derien.co.bw" className="text-gray-600 hover:text-navy" data-id="element-50">
                  derien@derien.co.bw
                </a>
              </div>
            </div>

            <div className="flex items-start" data-id="element-51">
              <div className="bg-white p-3 rounded-lg shadow-sm mr-4" data-id="element-52">
                <Clock className="h-6 w-6 text-gold" data-id="element-53" />
              </div>
              <div data-id="element-54">
                <h4 className="font-bold text-navy" data-id="element-55">Business Hours</h4>
                <p className="text-gray-600" data-id="element-56">Mon - Fri: 8:00 AM - 5:00 PM</p>
                <p className="text-gray-600" data-id="element-57">Sat: 9:00 AM - 1:00 PM</p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white p-8 rounded-xl shadow-lg border-t-4 border-gold" data-id="element-58">
          <h3 className="text-2xl font-bold text-navy mb-6" data-id="element-59">
            Send us a Message
          </h3>
          <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-60">
            <div className="grid grid-cols-2 gap-4" data-id="element-61">
              <div data-id="element-62">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-63">
                  First Name
                </label>
                <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold focus:border-transparent outline-none" placeholder="John" data-id="element-64" />
              </div>
              <div data-id="element-65">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-66">
                  Last Name
                </label>
                <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold focus:border-transparent outline-none" placeholder="Doe" data-id="element-67" />
              </div>
            </div>
            <div data-id="element-68">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-69">
                Email Address
              </label>
              <input type="email" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold focus:border-transparent outline-none" placeholder="john@example.com" data-id="element-70" />
            </div>
            <div data-id="element-71">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-72">
                Phone Number
              </label>
              <input type="tel" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold focus:border-transparent outline-none" placeholder="+267 74 833 041" data-id="element-73" />
            </div>
            <div data-id="element-74">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-75">
                Message
              </label>
              <textarea rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold focus:border-transparent outline-none" placeholder="How can we help you?" data-id="element-76"></textarea>
            </div>
            <button type="submit" className="w-full bg-navy text-white font-bold py-3 rounded-lg hover:bg-navy-light transition-colors shadow-md" data-id="element-77">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </Section>;
}